import React, {useRef, useEffect, useState} from 'react';
import classnames from 'classnames';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';
import ModalFormDataAndFileList from '../ModalShumaFilesList';
import ModalSendFinalPDF from '../ModalSendFinalPDF';
import AnimatedUploadingFilePopUp from '../AnimatedUploadingFilePopUp';
import PopupNotes from "../PopupNotes";
import {PopupNotesContextProvider} from "../PopupNotes/contexts/PopupNotesContext";
import threeDots from 'modules/InspectedList/assets/three-dots.svg';
import edit from 'modules/InspectedList/assets/edit.svg';
import download from 'modules/InspectedList/assets/download.svg';
import {shumaStatusTypeIds as STATUS} from '../../../modules/Inspection/constants/shumaStatusTypeIds';
import styles from './styles.module.scss';

const Menu = ({
                isOpen,
                editAllowed,
                onEdit,
                onEditOther,
                itemProps,
                shumaTypeID,
                originTypeID,
                shumaStatusTypeID,
                shumaId,
                firmShumaID,
                fileID,
                bankEmail,
                handleDownloadPDF,
                loading
              }) => {
  const [menuFalls, setMenuFalls] = useState(false);
  const menuRef = useRef(null);
  const shumaCompleted = ((shumaStatusTypeID === STATUS.COMPLETED || shumaStatusTypeID === STATUS.COMPLETED_MANUALLY) && originTypeID === 1);

  useEffect(() => {
    if (checkMenuFallsFromViewport()) {
      setMenuFalls(true);
    } else {
      setMenuFalls(false);
    }
  }, [isOpen]);

  const checkMenuFallsFromViewport = () => {
    if (isOpen && Boolean(menuRef.current)) {
      const {bottom} = menuRef.current.getBoundingClientRect();
      return bottom > window.innerHeight;
    }
    return false;
  };

  return (
    <div
      className={classnames(styles.visible, {
        [styles.alignToBottom]: menuFalls,
      })}
      role="menu"
      ref={menuRef}
    >
      <div className={styles.popup}>
        {(editAllowed) && (
          <div
            className={styles.menuItem}
            onClick={onEdit}
            {...itemProps[0]}
            role="menuitem"
          >
            <img src={edit} alt="edit" className={styles.icon}/>
            <p className={styles.label}>עריכה</p>
          </div>
        )}
        {(shumaCompleted && fileID) &&
          <div
            className={styles.menuItem}
            onClick={handleDownloadPDF}
            {...itemProps[1]}
            role="menuitem"
          >
            <img src={download} alt="download" className={styles.icon}/>
            <p className={styles.label}>הורדה</p>
            <AnimatedUploadingFilePopUp show={loading}/>
          </div>
        }
        <div {...itemProps[2]} role="menuitem" className={styles.menuItem}>
          <ModalFormDataAndFileList shumaId={shumaId} firmShumaID={firmShumaID}/>
        </div>
        {(shumaCompleted) &&
          <div {...itemProps[3]} role="menuitem" className={styles.menuItem}>
            <ModalSendFinalPDF
              shumaId={shumaId}
              message={'האם לשלוח את הדוח הסופי ללקוחות?'}
              buttonLabel={'שלח ללקוח'}
              recipientType={1}
              recipientTypeLabel={'customer'}
              bankEmail={''}
            />
          </div>
        }
        {(shumaTypeID !== 1 && shumaCompleted) &&
          <div {...itemProps[4]} role="menuitem" className={styles.menuItem}>
            <ModalSendFinalPDF
              shumaId={shumaId}
              message={'האם לשלוח את הדוח הסופי לבנק?'}
              buttonLabel={'שלח לבנק'}
              recipientType={2}
              recipientTypeLabel={'bank'}
              bankEmail={bankEmail}
            />
          </div>
        }
        {(shumaCompleted) &&
          <div {...itemProps[5]} role="menuitem" className={styles.menuItem}>
            <ModalSendFinalPDF
              shumaId={shumaId}
              message={'אנא הזינו כתובת מייל לשליחה ומלל לגוף ההודעה'}
              buttonLabel={'שלח לצד ג'}
              recipientType={3}
              recipientTypeLabel={'other'}
              bankEmail={bankEmail}
            />
          </div>
        }
        {(originTypeID === 3) &&
          <div
            className={styles.menuItem}
            onClick={onEditOther}
            {...itemProps[6]}
            role="menuitem"
          >
            <img src={edit} alt="edit" className={styles.icon}/>
            <p className={styles.label}>עריכת דוח</p>
          </div>
        }
        <div {...itemProps[7]} role="menuitem" className={styles.menuItem}>
          <PopupNotesContextProvider shumaID={shumaId}>
            <PopupNotes firmShumaID={firmShumaID}/>
          </PopupNotesContextProvider>
        </div>
      </div>
    </div>
  );
};

const ButtonDropdownActionsView = ({
                                     shumaId,
                                     firmShumaID,
                                     onEdit,
                                     onEditOther,
                                     editAllowed = false,
                                     shumaTypeID,
                                     originTypeID,
                                     shumaStatusTypeID,
                                     fileID,
                                     bankEmail,
                                     loading,
                                     handleDownloadPDF
                                   }) => {
  const {buttonProps, itemProps, isOpen} = useDropdownMenu(6);
  const menuProps = {
    isOpen,
    editAllowed,
    onEdit,
    onEditOther,
    itemProps,
    shumaId,
    firmShumaID,
    shumaTypeID,
    originTypeID,
    shumaStatusTypeID,
    fileID,
    bankEmail,
    loading,
    handleDownloadPDF
  };

  return (
    <div className={styles.buttonDropdownActions}>
      <div  {...buttonProps} className={styles.button}>
        <img
          src={threeDots}
          alt="open popup"
        />
      </div>
      <div className={isOpen ? styles.visible : styles.hidden} role="menu">
        <Menu {...menuProps}/>
      </div>
    </div>
  );
};

export default ButtonDropdownActionsView;